'use client'
import { createPortal } from 'react-dom'

import { tw } from '@/lib/utils'

import sheetStyles from '../sheet/nav-mobile-sheet-styles'
import type { SheetState } from '../sheet/use-sheet-presence'

// Dim only below the topbar: dark routes keep the hero visible through their
// transparent bar. Portal to <body> so the nav's transform cannot contain this
// fixed layer. A press on it lands outside
// every [data-menu-clickaway] element, so the desktop click-away closes the menu.
export const LauncherScrim = ({ state, dark, top }: { state: SheetState; dark: boolean; top: number }) =>
  createPortal(
    <div
      aria-hidden
      style={{ top }}
      className={tw(
        'fixed inset-0 z-[1005] transition-opacity duration-300 ease-out motion-reduce:transition-none',
        sheetStyles.scrim,
        dark && sheetStyles.scrimDark,
        state === 'open' ? 'opacity-100' : 'opacity-0'
      )}
    />,
    document.body
  )
